<template>
  <div />
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectStats } from 'instantsearch.js/es/connectors';

export default {
  mixins: [
    createWidgetMixin({ connector: connectStats }),
  ],
  props: {
    indexName: { type: String, default: '' },
  },
  computed: {
    nbHits() {
      // console.log(this.state)
      return this.state && this.state.nbHits;
    },
  },
  watch: {
    nbHits() {
      this.$emit('nbHitsChange', this.indexName, this.nbHits);
    },
  },
};
</script>
